import useWindowDimensions from "hooks/useWindowDimension";
import { GifOptionsDesktop } from "./GifOptionsDesktop";
import { GifOptionsMobile } from "./GifOptionsMobile";
import { IGif } from "services/types";

interface IProps {
  gif: IGif;
  anchorEl: HTMLElement | null;
  onShare: () => void;
  onAddToNiche: () => void;
  onChangeVisibility: () => void;
  onDelete: () => void;
  onClose: () => void;
  onEditGallery?: (gallery?: string) => void;
}

export const GifOptions = (props: IProps) => {
  const {
    gif,
    anchorEl,
    onShare,
    onChangeVisibility,
    onDelete,
    onClose,
    onAddToNiche,
    onEditGallery,
  } = props;

  const isDesktop = useWindowDimensions();

  return (
    isDesktop ? (
      <GifOptionsDesktop
        gif={gif}
        anchorEl={anchorEl}
        onShare={onShare}
        onAddToNiche={onAddToNiche}
        onChangeVisibility={onChangeVisibility}
        onDelete={onDelete}
        onEditGallery={onEditGallery}
        onClose={onClose}
      />
    ) : (
      <GifOptionsMobile
        gif={gif}
        onShare={onShare}
        onAddToNiche={onAddToNiche}
        onChangeVisibility={onChangeVisibility}
        onDelete={onDelete}
        onEditGallery={onEditGallery}
        onClose={onClose}
      />
    )
  );
};
